<template>
    <div class="job-detail job-detail--programator">
        <div class="job-detail__heading">
            <h2>
                Jsi PHP vývojář/ka, kterého nebaví korporátní rutina a hledá smysluplnou práci na zajímavých projektech?
            </h2>
        </div>
        <div class="job-detail__subheading">
            <div class="job-detail__subheading__spacer-block">
                <div class="job-detail__subheading__spacer-block__line"></div>
            </div>
            <div class="job-detail__subheading__text-block">
                <p>Chceš pracovat v menším týmu lidí, kteří dělají to, co je baví? Pokud ano, pak se přidej k nám! Pracujeme na rozmanitých zakázkách, od webových aplikací, přes komplexní e-commerce řešení až po různorodé integrace a automatizace.</p>
            </div>
        </div>
        <div class="job-detail__text">
            <br><br>
            <h3>Koho hledáme?</h3>
            <ul>
                <li>Máš základní znalost PHP (objektové programování) a SQL.</li>
                <li>Rozumíš si s HTML, CSS a JS.</li>
                <li>Jsi zodpovědný/á a je na tebe spolehnutí.</li>
                <li>Znalost Nuxt, Vue.js výhodou.</li> 
            </ul>
            <br><br>
            <h3>Co ti nabízíme?</h3>
            <ul>
                <li>Zajímavé projekty s různorodými technologiemi.</li>
                <li>Nemusíš se bát, že nebudeš vědět kudy kam. Budeš mít k ruce zkušeného programátora Roberta, který ti poradí a probere s tebou vše, co budeš potřebovat.</li>
                <li>Nečekáme, že budeš vše vědět hned. Ze startu si zkusíš jednoduché úkoly a postupně dostaneš více dlouhodobých projektů, o které se budeš starat.</li>
                <li>Komunikaci s klientem vždy zajistí projekťák, který ti bude k ruce.</li>
                <li>Možnost růst a učit se nové věci.</li>
                <li>Práci na full-time, po domluvě možnost i 4denní pracovní týden.</li>
                <li>Různorodá práce – žádné nekonečné ladění jednoho formuláře.</li>
                <li>Možnost ovlivnit, jak budou naše projekty vypadat a fungovat.</li>
                <li>Flexibilní pracovní dobu a po domluvě občasný home office.</li>
            </ul>
            <br><br>
            <h3>Co ti nabízíme?</h3>
            <ul>
                <li>Na co se můžeš u nás ještě těšit?</li>
                <li>Firemní kulturu postavenou na otevřenosti, důvěře a férovém jednání.</li>
                <li>Měsíční turnaje v různých sportech, neboť ve zdravém těle zdravý duch. 🕺</li>
                <li>Teambuildingové aktivity a neformální setkání.</li>
                <li>Vybavení, stravenky a káva je samozřejmostí.</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
    .job-detail {
        h2 {
            color: #212529;
            letter-spacing: -.02em;
            margin-top: 0;
            margin-bottom: 0;
            font-size: 30px;
            font-weight: 700;
            line-height: 100%;
            text-align: center;

            @media (min-width: 768px) {
                font-size: 40px;
                text-align: left;
            }

            @media (min-width: 992px) {
                font-size: 50px;
            }

            @media (min-width: 1200px) {
                font-size: 68px;
            }
        }

        .job-detail__heading {
            margin-bottom: 40px;
        }

        .job-detail__subheading {
            .job-detail__subheading__text-block {
                p {
                    color: rgb(130, 131, 132);
                    font-weight: 400;
                    font-size: 20px;
                    line-height: 1.5;
                    text-align: center;
                }
            }

            @media (max-width: 767px) {
                .job-detail__subheading__spacer-block {
                    display: none;
                }
            }

            @media (min-width: 768px) {
                display: flex;
                grid-column-gap: 32px;
                justify-content: space-between;
                align-items: baseline;

                .job-detail__subheading__spacer-block {
                    flex: 1;
                    .job-detail__subheading__spacer-block__line {
                        background-color: rgb(130, 131, 132);
                        width: 100%;
                        height: 1px;
                    }
                }

                .job-detail__subheading__text-block {
                    width: 68%;

                    p {
                        font-size: 22px;
                        text-align: left;
                    }
                }
            }
        }

        .job-detail__text {
            h3 {
                font-size: 26px;
                line-height: 1.1;
                font-weight: 900;
                margin: 0 0 0.68em;
                padding: 0;

                @media (min-width: 768px) {
                    font-size: 30px;
                }

                @media (min-width: 992px) {
                    font-size: 36px;
                }

                @media (min-width: 1200px) {
                    font-size: 42px;
                }
            }

            ul {
                padding-left: 12px;
                list-style-type: "–";
                margin: 0;
                li {
                    padding: 0 0 6px 12px;
                    font-size: 18px;
                    line-height: 1.6;
                    color: #212529;
                }
            }
        }
    }
</style>